import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaUsers, FaHandshake, FaClipboardCheck } from 'react-icons/fa';

const Counter = ({ icon: Icon, endValue, label, delay }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // milliseconds
      const incrementTime = 50; // milliseconds
      const steps = duration / incrementTime;
      const increment = endValue / steps;

      const timer = setInterval(() => {
        start += increment;
        if (start > endValue) {
          start = endValue;
          clearInterval(timer);
        }
        setCount(Math.ceil(start));
      }, incrementTime);

      return () => clearInterval(timer);
    }
  }, [inView, endValue]);

  return (
    <motion.div
      ref={ref}
      className="flex flex-col items-center p-6 bg-white rounded-xl shadow-lg border border-gray-200"
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay: delay }}
    >
      <Icon className="text-5xl text-blue-600 mb-4" />
      <div className="text-5xl font-extrabold text-gray-800 mb-2">
        {count}+
      </div>
      <p className="text-xl font-semibold text-gray-600 text-center">{label}</p>
    </motion.div>
  );
};

const CountersSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Nuestros Números Hablan por Sí Solos
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <Counter icon={FaUsers} endValue={500} label="Clientes Satisfechos" delay={0.4} />
          <Counter icon={FaHandshake} endValue={10} label="Años de Experiencia" delay={0.6} />
          <Counter icon={FaClipboardCheck} endValue={1200} label="Trámites Realizados" delay={0.8} />
        </div>
      </div>
    </section>
  );
};

export default CountersSection;